import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function FinalCTASection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  const checkoutUrl = 'https://checkout.guiadigital360.online/cart/43928145002565:1';
  return <section className="py-24 px-4 bg-brand-dark text-white text-center" data-id="element-92">
      <div className="max-w-4xl mx-auto" data-id="element-93">
        <div className="inline-block bg-white/10 text-white font-bold px-6 py-2 rounded-full mb-8 border border-white/20" data-id="element-94">
          🧪 QUÍMICA EN ACCIÓN
        </div>

        <h2 className="text-3xl md:text-5xl font-black mb-8 leading-tight" data-id="element-95">
          El próximo domingo podés seguir buscando material en Google.
          <br data-id="element-96" />
          <span className="text-brand-orange" data-id="element-97">
            O podés tener todo resuelto desde hoy.
          </span>
        </h2>

        <div className="bg-[#252542] p-8 rounded-3xl border border-gray-700 mb-12" data-id="element-98">
          <p className="text-xl font-bold text-gray-300 mb-4" data-id="element-99">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex justify-center gap-4 mb-6" data-id="element-100">
            <div className="text-4xl md:text-5xl font-black text-brand-orange" data-id="element-101">
              {formatTime(hours)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-102">hs</span>
            </div>
            <div className="text-4xl md:text-5xl font-black text-gray-500" data-id="element-103">
              :
            </div>
            <div className="text-4xl md:text-5xl font-black text-brand-orange" data-id="element-104">
              {formatTime(minutes)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-105">min</span>
            </div>
            <div className="text-4xl md:text-5xl font-black text-gray-500" data-id="element-106">
              :
            </div>
            <div className="text-4xl md:text-5xl font-black text-brand-orange" data-id="element-107">
              {formatTime(seconds)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-108">seg</span>
            </div>
          </div>
          <p className="text-red-400 font-bold" data-id="element-109">
            Después sube $10.000 ARS y no vuelve.
          </p>
        </div>

        <div className="space-y-6 max-w-2xl mx-auto mb-12" data-id="element-110">
          {/* Highlighted Pack */}
          <div className="bg-white text-brand-dark p-6 rounded-2xl shadow-2xl border-4 border-brand-orange relative" data-id="element-111">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-brand-orange text-white font-black px-4 py-1 rounded-full text-xs" data-id="element-112">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-4" data-id="element-113">
              <div className="text-left" data-id="element-114">
                <h3 className="text-2xl font-black flex items-center gap-2" data-id="element-115">
                  🏆 PACK COMPLETO
                </h3>
              </div>
              <div className="text-3xl font-black text-brand-orange" data-id="element-116">
                $30.980 pesos
              </div>
            </div>
            <CTAButton text="→ QUIERO MI MEGAPACK COMPLETO" href="https://checkout.guiadigital360.online/cart/44770181808197:1" isLink={true} data-id="element-117" />
          </div>

          {/* Other Packs */}
          <div className="grid md:grid-cols-2 gap-6" data-id="element-118">
            <div className="bg-[#252542] p-6 rounded-2xl border border-gray-700" data-id="element-119">
              <h3 className="text-xl font-bold mb-2" data-id="element-120">📘 PACK INICIACIÓN</h3>
              <div className="text-2xl font-black text-white mb-4" data-id="element-121">
                $19.990 pesos
              </div>
              <CTAButton text="→ QUIERO PACK INICIACIÓN" href={checkoutUrl} isLink={true} className="text-sm py-3" data-id="element-122" />
            </div>
            <div className="bg-[#252542] p-6 rounded-2xl border border-gray-700" data-id="element-123">
              <h3 className="text-xl font-bold mb-2" data-id="element-124">📗 PACK AVANZADO</h3>
              <p className="text-xs text-gray-400 mb-2" data-id="element-125">
                Incluye Pack Iniciación + Cuadernillos Bs. As. + Drive
              </p>
              <div className="text-2xl font-black text-white mb-4" data-id="element-126">
                $24.990 pesos
              </div>
              <CTAButton text="→ QUIERO PACK AVANZADO" href="https://checkout.guiadigital360.online/cart/44552070725701:1" isLink={true} className="text-sm py-3" data-id="element-127" />
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-gray-400 font-medium" data-id="element-128">
          <span className="flex items-center gap-2" data-id="element-129">
            <LockIcon className="w-5 h-5" data-id="element-130" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-131">
            <ZapIcon className="w-5 h-5 text-yellow-500" data-id="element-132" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-133">
            <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-134" /> Garantía 7
            días sin preguntas
          </span>
          <span className="flex items-center gap-2" data-id="element-135">
            <CreditCardIcon className="w-5 h-5" data-id="element-136" /> Mercado Pago | Tarjeta |
            Transferencia
          </span>
        </div>
      </div>
    </section>;
}